import React from 'react';
import { ReactComponent as LogoBlueMark } from '../../assets/LOGO BLUE.svg';
import { ReactComponent as LogoNegativeMark } from '../../assets/LOGO NEGATIVE.svg';
import fedexporLogo from '../../assets/cropped-fedexpor-logo-neg-768x209.png';

export const LogoBlue = ({ className = 'h-8 w-auto' }) => (
  <LogoBlueMark className={`${className} overflow-visible text-[#102E4A] [&_path]:fill-current`} aria-label="Lytiks" focusable="false" />
);

export const LogoNegative = ({ className = 'h-8 w-auto' }) => (
  <LogoNegativeMark className={`${className} overflow-visible text-[#FBF9E4] [&_path]:fill-current`} aria-label="Lytiks" focusable="false" />
);

export const FedexporInitiative = ({ compact = false, className = '' }) => (
  <div className={`text-center ${className}`}>
    <p className={`${compact ? 'text-[0.56rem]' : 'text-[0.68rem]'} font-bold uppercase tracking-[0.34em] text-[#5C7390]`}>
      Una iniciativa de
    </p>
    <div className={`${compact ? 'mt-3 h-[72px] rounded-xl px-5' : 'mt-3.5 h-[96px] rounded-[22px] px-7'} mx-auto flex w-full max-w-[420px] items-center justify-center border border-white/70 bg-white shadow-[0_18px_45px_rgba(82,105,130,0.12)]`}>
      <img
        src={fedexporLogo}
        alt="Fedexpor"
        className={`${compact ? 'max-h-10 max-w-[230px]' : 'max-h-[58px] max-w-[320px]'} h-auto w-full object-contain`}
      />
    </div>
    <div className={`${compact ? 'mt-4 max-w-[180px]' : 'mt-5 max-w-[240px]'} mx-auto flex h-1 overflow-hidden rounded-full`}>
      <span className="basis-1/2 bg-[#FF9F00]" />
      <span className="basis-1/2 bg-[#7B9BC7]" />
    </div>
    <p className={`${compact ? 'mt-3 text-sm' : 'mt-4 text-[1.2rem]'} font-bold leading-tight text-[#5C7390]`}>
      Barómetro Naviero Ecuador
    </p>
  </div>
);

export const PoweredByLytiks = ({ variant = 'light', className = '' }) => {
  const isDark = variant === 'dark';
  const textColor = isDark ? 'text-white/45' : 'text-slate-300';
  const Logo = isDark ? LogoNegative : LogoBlue;

  return (
    <div className={`flex items-center justify-center gap-2 ${textColor} ${className}`}>
      <span className="text-[0.55rem] font-semibold uppercase tracking-[0.2em] leading-none">
        Powered by
      </span>
      <Logo className={`${isDark ? 'h-4 opacity-75' : 'h-4 opacity-55'} mr-1 w-auto`} />
    </div>
  );
};

export const SidebarFedexporMark = ({ className = '' }) => (
  <div className={`w-[142px] sm:w-[154px] ${className}`}>
    <p className="mb-1.5 text-[0.48rem] font-semibold uppercase tracking-[0.2em] text-white/35">
      Una iniciativa de
    </p>
    <div className="rounded-lg border border-white/80 bg-white px-2.5 py-1.5 shadow-[0_10px_24px_rgba(0,0,0,0.12)]">
      <img
        src={fedexporLogo}
        alt="Fedexpor"
        className="h-auto max-h-[22px] w-full object-contain sm:max-h-[24px]"
      />
    </div>
    <div className="mt-2 flex h-0.5 w-16 overflow-hidden rounded-full sm:w-20">
      <span className="basis-1/2 bg-[#FF9F00]" />
      <span className="basis-1/2 bg-[#7B9BC7]" />
    </div>
  </div>
);
